import { SensorType } from '@innovyze/shared-utils';
import { InputText } from '@innovyze/stylovyze/lib/components';
import { FormControl } from '@mui/material';
import { useGlobalization } from '../../../contexts';
import { CurveManagerDialogs, CurveType, } from '../../../types/curveManager.types';
import { useIsFeatureEnabled } from '../../../utils';
import React from 'react';
import { FieldDropDown } from './components/FieldDropDown';
import { FormLayoutColumn, FormLayoutRow } from './components/FormLayout';
import { CurveDialogForm } from './CurveManagerDialogForm.styles';
import { efficiencyOptions, flowRateOptions, headOptions, levelOptions, powerOptions, pressureOptions, volumeOptions, } from './utils';
import { useSelectCurveManager } from '@innovyze/stylovyze/lib/selectors';
import { curveTypeOptions } from '@innovyze/stylovyze/lib/utils/curveManagerUtils';
const CurveManagerDialogForm = ({ formikProps, }) => {
    const { t } = useGlobalization();
    const isCurveUnitsEnabled = useIsFeatureEnabled('info-360-analytics-manufacture-curve-units');
    const { dialog } = useSelectCurveManager();
    const isEdit = dialog === CurveManagerDialogs.EditCurve;
    const [curveType, setCurveType] = React.useState(formikProps.values.curveType);
    const [xAxisLabel, setXAxisLabel] = React.useState(t('Flow Rate Unit (X-Axis)'));
    const [yAxisLabel, setYAxisLabel] = React.useState(t('Pressure Unit (Y-Axis)'));
    const [xAxisOptions, setXAxisOptions] = React.useState(flowRateOptions(t));
    const [yAxisOptions, setYAxisOptions] = React.useState(pressureOptions(t));
    React.useEffect(() => {
        let xAxisSensorType, yAxisSensorType, newXAxisLabel = '', newYAxisLabel = '', newXAxisOptions = [], newYAxisOptions = [];
        switch (curveType) {
            case CurveType.PRESSURE_CURVE:
            case CurveType.SYSTEM_CURVE:
                xAxisSensorType = SensorType.FlowRate;
                yAxisSensorType = SensorType.Pressure;
                newXAxisLabel = t('Flow Rate Unit (X-Axis)');
                newYAxisLabel = t('Pressure Unit (Y-Axis)');
                newXAxisOptions = flowRateOptions(t);
                newYAxisOptions = pressureOptions(t);
                break;
            case CurveType.HEAD_CURVE:
                xAxisSensorType = SensorType.FlowRate;
                yAxisSensorType = SensorType.Head;
                newXAxisLabel = t('Flow Rate Unit (X-Axis)');
                newYAxisLabel = t('Head Unit (Y-Axis)');
                newXAxisOptions = flowRateOptions(t);
                newYAxisOptions = headOptions(t);
                break;
            case CurveType.TANK_CURVE:
                xAxisSensorType = SensorType.Level;
                yAxisSensorType = SensorType.Volume;
                newXAxisLabel = t('Level Unit (X-Axis)');
                newYAxisLabel = t('Volume Unit (Y-Axis)');
                newXAxisOptions = levelOptions(t);
                newYAxisOptions = volumeOptions(t);
                break;
            case CurveType.POWER_CURVE:
                xAxisSensorType = SensorType.FlowRate;
                yAxisSensorType = SensorType.Power;
                newXAxisLabel = t('Flow Rate Unit (X-Axis)');
                newYAxisLabel = t('Power Unit (Y-Axis)');
                newXAxisOptions = flowRateOptions(t);
                newYAxisOptions = powerOptions(t);
                break;
            case CurveType.EFFICIENCY_CURVE:
                xAxisSensorType = SensorType.FlowRate;
                yAxisSensorType = SensorType.Percent;
                newXAxisLabel = t('Flow Rate Unit (X-Axis)');
                newYAxisLabel = t('Efficiency Unit (Y-Axis)');
                newXAxisOptions = flowRateOptions(t);
                newYAxisOptions = efficiencyOptions(t);
                break;
        }
        setXAxisLabel(newXAxisLabel);
        setYAxisLabel(newYAxisLabel);
        setXAxisOptions(newXAxisOptions);
        setYAxisOptions(newYAxisOptions);
        if (formikProps.values.curveData.xSeries?.type !== xAxisSensorType) {
            formikProps.setFieldValue('curveData.xSeries', {
                type: xAxisSensorType,
                unit: newXAxisOptions[0]?.value,
            });
        }
        if (formikProps.values.curveData.ySeries?.type !== yAxisSensorType) {
            formikProps.setFieldValue('curveData.ySeries', {
                type: yAxisSensorType,
                unit: newYAxisOptions[0]?.value,
            });
        }
    }, [curveType]);
    return (React.createElement(CurveDialogForm, { onSubmit: formikProps.handleSubmit },
        React.createElement(FormControl, { variant: "outlined", fullWidth: true },
            React.createElement(FormLayoutRow, null,
                React.createElement(FormLayoutColumn, null,
                    React.createElement(InputText, { textField: {
                            margin: 'dense',
                            required: true,
                            error: !!formikProps?.errors?.curveName,
                            helperText: formikProps?.errors?.curveName,
                            variant: 'outlined',
                            label: t('Name'),
                            disabled: isEdit,
                        }, fieldAttrs: {
                            name: 'curveName',
                        } })),
                React.createElement(FormLayoutColumn, null,
                    React.createElement(FieldDropDown, { dataCy: "field-curveType", label: t('Type'), name: "curveType", options: curveTypeOptions(t), onChange: value => setCurveType(value?.value ??
                            CurveType.PRESSURE_CURVE), style: { flex: 1 }, margin: "dense", disabled: isEdit }))),
            isCurveUnitsEnabled && (React.createElement(React.Fragment, null,
                React.createElement(FormLayoutRow, null,
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(FieldDropDown, { dataCy: "x-field-manufacturerCurve-unit", label: xAxisLabel, name: "curveData.xSeries.unit", options: xAxisOptions, style: { flex: 1 }, required: true, margin: "dense" })),
                    React.createElement(FormLayoutColumn, null,
                        React.createElement(FieldDropDown, { dataCy: "y-field-manufacturerCurve-unit", label: yAxisLabel, name: "curveData.ySeries.unit", options: yAxisOptions, style: { flex: 1 }, required: true, margin: "dense" }))))))));
};
export default CurveManagerDialogForm;
